import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import SearchComponent from '../PricingHub/SearchComponent';

class InvoicePaymentInstallmentSearchForm extends SearchComponent {
  searchInputs = [
    {
      label: 'label.status',
      name: 'installmentStatus',
      type: 'select',
      tOptions: 'selections:installmentStatus',
      isClearable: true,
    },
  ];

  btnSpan = 'col-md-9';
}

InvoicePaymentInstallmentSearchForm.propTypes = {
  onSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
};

InvoicePaymentInstallmentSearchForm.defaultProps = {
  isSubmitting: false,
};

export default withTranslation(['common', 'selections'])(InvoicePaymentInstallmentSearchForm);
